import Vue from 'vue';
export const EventManager = new Vue();
